import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";

interface RadioOption {
	label: string;
	value: any;
}

interface Props extends WithStyles<typeof styles> {
	default?: boolean;
	label?: string;
	onChange: (value: any) => void;
	options: RadioOption[];
	row?: boolean;
	value: any;
	sidebarNote?: React.ReactNode;
	stacked?: boolean;
}

class Component extends React.Component<Props> {
	public render() {
		const { classes = {}, label, onChange, options, row, sidebarNote, stacked } = this.props;
		const value =
			this.props.value !== undefined
				? this.props.value
				: this.props.default || false;
		const radioGroup = (
			<Mui.RadioGroup
				className={stacked ? classes.stackedGroup : undefined}
				row={row}
				value={value}
				onChange={(event) => {
					onChange(event.target.value);
				}}
			>
				{options.map((option) => {
					return (
						<Mui.FormControlLabel
							key={option.label}
							label={option.label}
							control={<Mui.Radio />}
							value={option.value}
						/>
					);
				})}
			</Mui.RadioGroup>
		);

		return (
			<Mui.Grid container direction="row" spacing={2}>
				<Mui.Grid item xs>
					{stacked ? (
						<Mui.Grid container direction="column" spacing={1}>
							{label && (
								<Mui.Grid item>
									<Mui.Typography className={classes.label}>{label}</Mui.Typography>
								</Mui.Grid>
							)}
							<Mui.Grid item>{radioGroup}</Mui.Grid>
						</Mui.Grid>
					) : (
						<Mui.Grid container spacing={3}>
							{label && (
								<Mui.Grid item xs={8}>
									<Mui.Typography className={classes.label}>{label}</Mui.Typography>
								</Mui.Grid>
							)}
							<Mui.Grid item xs={label ? 4 : 12}>
								{radioGroup}
							</Mui.Grid>
						</Mui.Grid>
					)}
				</Mui.Grid>
				{sidebarNote && (
					<Mui.Grid item xs>
						<Mui.Typography>
							<strong>Note:</strong>
							{" "}
							{sidebarNote}
						</Mui.Typography>
					</Mui.Grid>
				)}
			</Mui.Grid>
		);
	}
}

export const CustomLabelRadioField = withStyles(Component, styles);
